<template>
  <div>
    <h6 class="mb-8 font-bold text-1xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('despachosmaquinaria')">Despacho / Compra:</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>
      {{  form.id}} 
    </h6>
    <trashed-message v-if="diario.deleted_at" class="mb-6" @restore="restore">
     Ingreso Eliminado!
    </trashed-message>
     <h1 class="mb-8 font-bold text-1xl"> Detalle de Ingreso de C{{i=0}}mpras </h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="updateventa">
       <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
           <select-input v-model="form.tipo" :error="form.errors.tipo" class="pr-6 pb-8 w-full lg:w-1/3" label="Tipo Gasolina">
            <option :value="diesel" >Diesel Premium</option>
          </select-input> 
         <text-input v-model="form2.numeroorden" :error="form.errors.peso" class="pr-6 pb-8 w-1/3" label="Nro. Orden" required/>
         <text-input v-model="form2.cantidad" :error="form.errors.cantidad" class="pr-6 pb-8 w-1/3" label="Cantidad de Galones" required/>
         <text-input v-model.number="form2.despacho_diarios_id" :error="form.errors.reporte_diario_id" class="invisible left-0 top-0 h-16 w-1/6" label="Nº"/> 
        
                    
          </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Agregar Compra</loading-button>
        </div>
      </form>
    </div>
    <br>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <div class="flex flex-col">
    <div class="overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="inline-block py-2 min-w-full sm:px-6 lg:px-8">
            <div class="overflow-hidden shadow-md sm:rounded-lg">
          <table class="min-w-full">
        <thead class="bg-gray-50 dark:bg-gray-700">
                        <tr>
                          <th scope="col" class="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                             Nº
                            </th>
                            <th scope="col" class="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                              Cantidad
                            </th>
                            <th scope="col" class="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                              Valor
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                      
    <tr v-for="detalle in detalles" :key="detalle.id" class="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
         <td>
            <inertia-link class="px-6 py-4 flex items-center" :href="route('despachocompras.edit', detalle.id)" tabindex="-1">
              {{ i=i+1}}
            </inertia-link>
          </td>
          <td>
            <inertia-link class="px-6 py-4 flex items-center" :href="route('despachocompras.edit', detalle.id)" tabindex="-1">
              {{ detalle.cantidad }}
            </inertia-link>
          </td>
          <td>
             <inertia-link class="px-6 py-4 flex items-center" :href="route('despachocompras.edit', detalle.id)" tabindex="-1">
              {{ detalle.valor }}
            </inertia-link>
          </td>
         
          <td class="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
            <inertia-link class="px-4 flex items-center" :href="route('despachocompras.edit', detalle.id)" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </inertia-link>
          </td>
        </tr>
        <tr v-if="detalles.length === 0">
          <td class="border-t px-6 py-4" colspan="4">No se encuentran datos</td>
        </tr>
       </tbody>
      </table>
            </div>
        </div>
    </div>
</div>
    </div>
    <br>
    <h1 class="mb-8 font-bold text-1xl"> Encabezado Ingreso </h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
 
       <form @submit.prevent="update">
       <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
       <text-input  v-model="form.fecha" :error="form.errors.fecha" class="pr-6 pb-8 w-full lg:w-2/6" label="Fecha" required/>                          
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Borrar Ingreso</button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Guardar y Pasar a los Despachos</loading-button>
        </div>
      </form>

    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import Datepicker from 'vuejs-datetimepicker'

export default {
  
  metaInfo() {
    return {
      title: `${this.form.id}`,
    }
  },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
    Datepicker
  },
  layout: Layout,
  props: {
    diario: Object,
    detalles: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        id: this.diario.id,
       fecha: this.diario.fecha,
      }),
       form2: this.$inertia.form({
        despacho_diarios_id: this.diario.id,
        numeroorden: null,
        cantidad: null,
        tipo: 'diesel',
        valor: null,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(this.route('despachosmaquinaria.update', this.diario.id))
    },
    updateventa() {
     this.form2.post(this.route('despachocompras.store'))
    },
    destroy() {
      if (confirm('Estas Seguro de Eliminar?')) {
        this.$inertia.delete(this.route('despachosmaquinaria.destroy', this.diario.id))
      }
    },
    restore() {
      if (confirm('Piensalo Bien!?')) {
        this.$inertia.put(this.route('despachosmaquinaria.restore', this.diario.id))
      }
    },
  },
  
}
</script>
